import React from 'react'
import classNames from 'classnames'
import style from './pulse-loader.module.css'

interface Props {
    size: number
}

const PulseLoader: React.FC<Props> = ({ size }) => {
    return (
        <span>
            {[1, 2, 3].map((itemNum) => (
                <span
                    className={classNames(
                        style.pulseLoader,
                        style[`size_${size}`],
                        style[`item_${itemNum}`],
                    )}
                ></span>
            ))}
        </span>
    )
}

export default PulseLoader
